// extracted by mini-css-extract-plugin
module.exports = {"gridIcons":"Icons_grid-icons__QHPqM","gridThumbIcon":"Icons_grid-thumb-icon__2nYRx"};